'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'searchBox/SET';

var initialState = {
  display: 'form'
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, state, { display: action.display });
    default:
      return state;
  }
}

function set(display) {
  return {
    type: SET,
    display: display
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/searchBox.js
// module id = 284
// module chunks = 0